import toastr from 'react-hot-toast';
export const getCleanJSONString = (jsonString: string) => {
  return jsonString.replace(/[\r\n]+/g, '').replace(/,\s*}/g, '}');
};

export function parseJSONCleaned<TConfig>(jsonString: string | undefined) {
  if (!jsonString) {
    return null;
  }
  try {
    const cleanedJsonString = getCleanJSONString(jsonString);

    return JSON.parse(cleanedJsonString) as TConfig;
  } catch (error) {
    console.error('Invalid JSON format');
    return null;
  }
}

export const isJSON = (str: string): boolean => {
  if (!str) {
    return false;
  }
  try {
    const parsedValue = JSON.parse(str);
    return typeof parsedValue === 'object' && parsedValue !== null;
  } catch (e) {
    return false;
  }
};

type KeyFunction<T> = (item: T | undefined) => string;

export const groupBy = <T>(
  arr: T[] | undefined,
  getKey: KeyFunction<T>
): Record<string, T[]> | undefined => {
  return arr?.reduce((acc: Record<string, T[]>, item: T) => {
    const key = getKey(item);
    acc[key] = acc[key] || [];
    acc[key].push(item);
    return acc;
  }, {});
};

export const isNullOrUndefined = (value: any) =>
  value === null || value === undefined;

export const capitalizeFirstLetter = (str: string) =>
  str?.charAt(0).toUpperCase() + str?.slice(1);

export const copyToClipboard = async (text: string | null) => {
  if (!text) {
    return;
  }
  await navigator.clipboard.writeText(text);
  toastr.success('copied');
};

export const getReviewText = (averageRating: number | undefined) => {
  if (!averageRating) {
    return 'No Reviews';
  }

  if (averageRating === 1) {
    return `${averageRating} Review`;
  }

  return `${averageRating} Reviews`;
};

export function generateRandomNumber(min: number, max: number) {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export const formatCredits = (credits: string | undefined) => {
  // This function is used to check and replace the decimal part of the credits mainly for spark run
  if (!credits) {
    return 0;
  }
  const [integerPart, decimalPart] = credits.split('.');
  const parsedDecimal = +decimalPart;

  if (!parsedDecimal || Number.isNaN(parsedDecimal)) {
    return +integerPart;
  }

  return +credits;
};

export const openAuthScreen = (redirectURL: string) => {
  const width = 500;
  const height = 600;
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const left = (screenWidth - width) / 2;
  const top = (screenHeight - height) / 2;
  window.open(
    redirectURL,
    'authPopup',
    `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,status=yes`
  );
};

export const getIsSearchableQuery = (query: string) => {
  const queryLength = query.trim().length;
  return Boolean(queryLength && queryLength >= 3);
};
export const isObjectEmpty = (testObject: object | any | undefined) => {
  return (
    Object.keys(testObject).length === 0 && testObject.constructor === Object
  );
};
